<template>
  <div :id="id" class="row">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.label"
      @input="$emit('input', component)"
      label="Label"
      placeholder="Label"
    />
    <LmTextInput
      :id="`nombre-${id}`"
      class="col-12 col-md-4"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      label="Nombre"
      placeholder="placeholder"
    />
    <LmTextInput
      :id="`disabled-option-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.options.disabledOption"
      @input="$emit('input', component)"
      label="Opción desabilitada"
      placeholder="Seleccione una opción"
    />
    <LmSelect
      :id="id + 'css'"
      class="col-12 col-md-4"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-3',text: '25%'},
          {value: 'col-12 col-md-6', text: '50%'},
          {value: 'col-12 col-md-9', text: '75%'},
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      label="Ancho vista escritorio"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <div class="col-12">
      <h5>Opciones</h5>
        <div
          v-for="(option, index) in component.componentProps.options.content"
          :key="index"
          class="row align-items-center"
          >
          <LmTextInput
            :id="`id-${id}-${index}`"
            class="col-12 col-md-5"
            v-model="component.componentProps.options.content[index].id"
            @input="$emit('input', component)"
            label="Id"
            placeholder="Id"
          />
          <LmTextInput
            :id="`name-${id}-${index}`"
            class="col-12 col-md-5"
            v-model="component.componentProps.options.content[index].name"
            @input="$emit('input', component)"
            label="Name"
            placeholder="name"
          />
          <font-awesome-icon
            :id="`trash-icon-${index}`"
            v-if="isAtLeastOneOption"
            class="clickable mt-3 col-12 col-md-1"
            icon="trash"
            @click="removeOption(index)" />
        </div>
        <LmButton
          :id="`lm-button-${id}`"
          type="button"
          value="Agregar opción"
          @click.native="addOption" />
    </div>
    <div class="col-12">
      <h5>Validacion</h5>
      <div class="row align-items-center">
        <div class="custom-control custom-checkbox col-12 col-md mt-1">
          <b-form-checkbox
            :name="component.formObjectToSendToServerProperty"
            v-model="validations.required"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
            >
            required
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :id="id"
      :leftValueToCompareOptions="leftValueToCompareOptions"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
      @input="$emit('input', component)"
      />
    <LmConditionalByEditModeBuilderUi
      :component="component"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false
      }
    }
  },
  components: {
    LmButton
  },
  computed: {
    isAtLeastOneOption () {
      return this.component.componentProps.options.content.length > 1
    }
  },
  methods: {
    addOption () {
      this.component.componentProps.options.content.push({ id: '', name: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.options.content.splice(optionIndex, 1)
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
